import { render, staticRenderFns } from "./TicketsTable.vue?vue&type=template&id=678a7a31"
import script from "./TicketsTable.vue?vue&type=script&lang=js"
export * from "./TicketsTable.vue?vue&type=script&lang=js"
import style0 from "./TicketsTable.vue?vue&type=style&index=0&id=678a7a31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports